require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-locations-nejapa.json") })
        }
      }, "path---en-locations-nejapa");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-locations-nejapa!./.cache/json/en-locations-nejapa.json
// module id = 1058
// module chunks = 231608221292675